module.exports = __webpack_public_path__ + "static/media/assignDriver.83c289cc.svg";